import { MarketingContentCreateInput, MarketingContentUpdateInput } from '@occc/graphql';

import { Operation } from '../types';

export type MakeMarketingContentCreateOperation = (
  input: Omit<MarketingContentCreateInput, 'locale'>,
) => Operation;

export type MakeMarketingContentUpdateOperation = (input: MarketingContentUpdateInput) => Operation;

export const makeMarketingContentCreateOperation: MakeMarketingContentCreateOperation = (
  input,
): Operation => ({
  name: 'marketingContentCreate',
  variables: {
    input: {
      locale: 'en_US',
      ...input,
    },
  },
});

export const makeMarketingContentUpdateOperation: MakeMarketingContentUpdateOperation = (
  input,
): Operation => ({
  name: 'marketingContentUpdate',
  variables: {
    input,
  },
});
